export { default as Promotion } from './Promotion';
